import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type ConditionMappingItem = {
    expressionId: string;
    conditionId: number;
    label: string;
    category: string;
};

export type ConversionMode = 'html' | 'native';

export type ExecuteMigrateTemplateInput = {
    htmlContent: string;
    templateName: string;
    subjectLine?: string;
    preHeader?: string;
    source: string;
    conversionMode: ConversionMode;
    tagMapping: Record<string, string>;
    conditionFieldMapping: Record<string, string>;
    conditionMapping: ConditionMappingItem[];
};

const useExecuteMigrateTemplate = (mutateOptions?: UseMutationOptions<unknown, Error, ExecuteMigrateTemplateInput>) =>
    useMutation<ExecuteMigrateTemplateInput>(
        MutationKeys.EXECUTE_MIGRATE_TEMPLATE,
        CuredApiPaths.TEMPLATES_MIGRATE_EXECUTE,
        mutateOptions
    );

export default useExecuteMigrateTemplate;
